import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ExpenseHeadMaster } from '../../models/expenseheadmaster';
import { PageHeader } from 'src/app/utils/models/page-header';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { ExpenseHeadService } from '../../services/expensehead.service';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { Department } from '../../models/department';
import { DepartmentService } from '../../services/department.service';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../models/company';
import { Division } from '../../models/division';
import { DivisionService } from '../../services/division.service';
import { LocationService } from '../../services/location.service';

@Component({
  selector: 'app-expensehead',
  templateUrl: './expensehead.component.html',
  styleUrls: ['./expensehead.component.css']
})
export class ExpenseHeadComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;

  headerEntity: PageHeader;
  private unsubscribe$: Subject<void> = new Subject<void>();
  entity: ExpenseHeadMaster = new ExpenseHeadMaster();
  saveentity: ExpenseHeadMaster = new ExpenseHeadMaster();
  editingEntity: ExpenseHeadMaster = new ExpenseHeadMaster();
  entities: any;
  parentExpenseHeads: Array<ExpenseHeadMaster>;
  entityColumns: any[] = [];
  listView: boolean = true;
  formCaption: string = '';
  rows: any;
  selectedParentExpHead: ExpenseHeadMaster = new ExpenseHeadMaster();
  Columns: any[];
  defaultRowsCount: number;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  saveDisabled: boolean = false;

  company: Array<Company> = [];
  selectedCompany: any;
  divisions: Array<Division> = [];
  selectedDivision: any;
  locations: Array<Location> = [];
  selectedLocation: any;
  departments: Array<Department> = [];
  selectedDepartment: any;

  constructor(
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private _companyService: CompanyService,
    private _divisionService: DivisionService,
    private _departmentService: DepartmentService,
    private _expenseHeadService: ExpenseHeadService,
    private notification: NotificationsService,
    private configService: ConfigService,
    private _locationService: LocationService,
  ) {
    this.headerEntity = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.entities = [];
    this.parentExpenseHeads = [];
    this.Columns = [
      { field: "SlNo", title: 'SL No', filter: false, sortable: true },
      { field: "ExpenseHeadName", title: 'Expense Head', filter: true, sortable: true  },
      { field: "ParentExpenseHeadName", title: 'Parent Expense Head', filter: true, sortable: true  },
      { field: "Active", title: 'Active', filter: true, sortable: true },  
    ];
    this.getAllExpenseHeads();
  }
  ngAfterViewInit(): void {

  }
  
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._expenseHeadService.getAllExpenseHeads('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<ExpenseHeadMaster>) => {
      this.entities = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._expenseHeadService.getAllExpenseHeads(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((res: Array<ExpenseHeadMaster>) => {
        this.entities = {
          data: res,
          total: res[0] ? res[0].TotalCount : 0
        }
      });
    }
  }
  getAllExpenseHeads() {
    this._expenseHeadService.getAllExpenseHeads('', Number(this.defaultPageSize), 1, 0, 0).subscribe((res: Array<ExpenseHeadMaster>) => {
      this.entities = {
        data: res,
        total: res[0] ? res[0].TotalCount : 0
      }
    });
  }

  refresh(event: any): void {
    this.getAllExpenseHeads();
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  addMode(event: any) {
    this.listView = false;
    this.clear();
    this.getAllParentExpenseHeads('');
    this.getAllCompany('');
    this.getAllDivisions('');
    this.getAllLocations('');
    this.getAllDepartments('');
    this.formCaption = "Add New Expense Head";
  }
  getAllParentExpenseHeads(filter: string) {
    this._expenseHeadService.getAllExpenseHeads(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<ExpenseHeadMaster>) => {
      this.parentExpenseHeads = data;
    })
  }
  getAllCompany(filter: string) {
    this._companyService.getAllCompany(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Company>) => {
      this.company = data;
    })
  }
  getAllLocations(filter: string) {
    this._locationService.getAllLocations(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<any>) => {
      this.locations = data;
    })
  } 
  getAllDepartments(filter: string) {
    this._departmentService.getAllDepartment(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Department>) => {
      this.departments = data;
    })
  }
  onPaste(event: any) {
    let Data = event.Data;
    let regexp = new RegExp('[^-_().;:,!a-zA-Z0-9/ ]');
    let pastedText = Data.getData('text');
    let test = regexp.test(pastedText);
    let trimmedText = pastedText.replace(/[^a-zA-Z0-9-()._ ]/g, '');
    (<HTMLInputElement>document.getElementById('bindingId')).value = trimmedText;
    if (test) {
      event.preventDefault();
    }
  }
  save(event: any): void {
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._expenseHeadService.checkDuplication(this.entity.ExpenseHeadName, this.entity.ExpenseHead_Id).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('Entry already exists');
          this.saveDisabled = false;
          // return;
        }
        else {
          this.saveentity.expenseHeadList = [];
          this.saveentity.ExpenseHead_Id = this.entity.ExpenseHead_Id;
          this.saveentity.ExpenseHeadName = this.entity.ExpenseHeadName;
          // this._expenseHeadService.saveExpenseHead(this.saveentity).subscribe(() => {
          //   if (this.entity.ExpenseHead_Id == '00000000-0000-0000-0000-000000000000') {
          //     this.notification.showSuccess('Saved Successfully');
          //   }
          //   else {
          //     this.notification.showSuccess('Updated Successfully');
          //   }
          //   this.listView = true;
          //   this.clear();
          //   this.getAllExpenseHeads();
          // })
        }
      });
    }
    else {
      this.saveDisabled = false;
    }
  }
  editMode(event: any): void {
    if (event.seletedRows[0]) {
      this._expenseHeadService.viewExpenseHead(event.seletedRows[0]).subscribe((response: any) => {
        let editMode = response.Data;
        if (editMode) {
          this.editingEntity = editMode;
          this.selectedCompany = { Company_Id: editMode.Company_Id, CompanyName: editMode.CompanyName };  
          this.selectedDivision = { Division_Id: editMode.Division_Id, DivisionName: editMode.DivisionName };
          this.selectedLocation = { Location_Id: editMode.Location_Id, LocationName: editMode.LocationName };
          this.selectedDepartment = { Department_Id: editMode.Department_Id, DepartmentName: editMode.DepartmentName };
          
          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Mode";
          this.getAllParentExpenseHeads('');
          this.entity.EntityMetaData = [
            { FieldName: 'ExpenseHeadName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Expense Head is required' },
            { FieldName: 'Company_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Company is required' },
            { FieldName: 'Division_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Division is required' },
            { FieldName: 'Location_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Location is required' },
            { FieldName: 'Department_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Department is required' },
          ];
        }
      });
    }
  }

  getAllDivisions(filter: string) {
    this._divisionService.getAllDivisions(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Division>) => {
      this.divisions = data;
    })
  }

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._expenseHeadService.deleteExpenseHead(this.selectedParentExpHead.ExpenseHead_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clear();
            this.getAllExpenseHeads();

          },
          )
        }
      }
    });
  }
  delete(event: any) {
    if (event.seletedRows[0]) {
      this.selectedParentExpHead.ExpenseHead_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry?",
          caption: "Expense Head",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }
  clear(): void {
    this.selectedCompany = {};
    this.entity = new ExpenseHeadMaster();
    this.saveDisabled = false;
  }

  onExcelExport() {
    this.excelexport.save()
  }

  gotoBack(): void {
    this.listView = true;
    this.getAllExpenseHeads();
  }

  initPageHeader(): PageHeader {
    let headerEntity = new PageHeader();
    headerEntity.PageCaption = "Expense Head";
    headerEntity.IconClass = "bi bi-cash-coin";
    return headerEntity;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }
}






